// Los negocios de demostración.
//
// Son negocios de verdad en la base, con sus servicios y sus horarios, y su
// página de reservas es la misma que la de cualquier cliente: ésa es la gracia,
// porque lo que se muestra es el producto y no una maqueta. Lo único que
// cambia es que se avisa que el turno no es real y que hay una salida hacia el
// registro.
//
// ─── Por qué son dos ───────────────────────────────────────────────────────
//
// Porque un club que entra a la demo de una barbería lee "profesional",
// "servicio" y "corte", y confirma justo lo que vino a sospechar: que esto no
// es para él. La demo sirve cuando la persona se ve a sí misma adentro, así
// que hay una por cada forma de hablar que tiene el producto.
//
// ─── Por qué los slugs están acá y no vienen del servidor ──────────────────
//
// Lo honesto sería una columna `es_demo` en tenants. Siguen siendo pocas y
// fijas: una lista en un archivo que se llama demo.js se encuentra buscando
// "demo", mientras que la columna cuesta una migración, un campo en /admin y
// una consulta más en el camino más caliente del producto —la página pública
// de reservas— para contestar algo que ya sabemos.
//
// El día que las demos las elija el operador desde /admin, esto se muda a la
// base. Mientras tanto, si cambian, cambian acá y en el SLUG_DEMO del api.
export const SLUGS_DEMO = ['barberia-del-centro', 'padel-del-parque'];

/** ¿Esta página de reservas es una demo? */
export const esDemo = (slug) => SLUGS_DEMO.includes(slug);

/** El texto del llamado a la acción. Está en un solo lugar porque sale en dos. */
export const INVITACION = '¿Lo querés para tu negocio? Probalo 7 días gratis';
